import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  Link as MaterialLink,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { useDeleteResultMutation, useDeleteResultsMutation, useGetResultsQuery } from '../../../store/data/dataSlice';
import { togglePauseTut } from '../../../store/tutorial/tutorialSlice';


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ResultsTable = (): JSX.Element => {
  const { data, error, isLoading } = useGetResultsQuery();
  const [open, setOpen] = useState(false);
  const [deleteResults] = useDeleteResultsMutation();
  const [deleteSelectMode, setDeleteSelectMode] = useState(false as boolean);
  const [deleteList, setDeleteList] = useState([] as string[])
  const tutorial = useAppSelector(state => state.tutorial);
  const dispatch = useAppDispatch();

  const handleClick = () => {
    if(tutorial.active && !tutorial.paused && tutorial.stepIndex == 23) {
      dispatch(togglePauseTut());
    }
  }

  const handleDelete = () => {
    setOpen(true);
  };
  
  const handleClose = (success: boolean) => {
    setOpen(false);
    if(deleteList.length > 0 && success) {
      deleteResults(deleteList);
      setDeleteList([]);
      setDeleteSelectMode(false);
    }
  };

  const handleCheckboxChange = (rid: string) => {
    if(deleteList.includes(rid)) {
      const newDeleteList = [...deleteList];
      setDeleteList(newDeleteList);
    }
    else {
      setDeleteList([...deleteList, rid]);
    }
  }

  if (error) {
    return <ErrorTypography message={'Error getting results'} />;
  } else {
    return (
      <div className='resultsTable'>
        <TableContainer>
          <TableHead>
             <TableRow>
               <TableCell>
              </TableCell>
              <TableCell>
                 <Trans>Pipeline</Trans>
              </TableCell>
              <TableCell>Result ID</TableCell>
              <TableCell>
                <Trans>Preview</Trans>
              </TableCell>
              <TableCell width={'120'} align={'center'}>
                {deleteSelectMode ? (
                  <>                  
                    <IconButton color={'success'} onClick={()=>{handleDelete()}}>
                      <CheckCircleRoundedIcon/>
                    </IconButton>
                    <IconButton color={'error'} onClick={()=>{setDeleteSelectMode(false); setDeleteList([])}}>
                      <CancelRoundedIcon/>
                    </IconButton>
                  </>
                ) : (
                  <IconButton color={'error'} onClick={()=>{setDeleteSelectMode(true)}}>
                    <DeleteOutlineRoundedIcon/>
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && data ? (
              data.slice(0).reverse().map((row,i) => (
                <StyledTableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, ...((row.solution==true && {backgroundColor: 'palegreen!important' as any}) || 
                (row.seen==false && {backgroundColor: 'InfoBackground!important' as any}))}} key={row.result_id}>
                  <TableCell component={'th'} scope={'row'}>
                  </TableCell>
                  <TableCell component={'th'} scope={'row'}>
                    <MaterialLink underline={'hover'} component={Link} to={`/results/${row.result_id}`}
                      onClick={handleClick}>
                      {row.pipeline}
                    </MaterialLink>
                  </TableCell>
                  <TableCell align={'right'} scope={'row'}>
                    {row.result_id}
                  </TableCell>
                  <TableCell>
                  <img width='100%' height='100%' src={`data:image/png;base64,${row.data_small}`} alt="visualization of the result"/>
                  </TableCell>
                  <TableCell align={'center'} scope={'row'}>
                    {deleteSelectMode &&
                      <Checkbox size={'medium'} onChange={()=>{handleCheckboxChange(row.result_id)}}/>
                    }
                  </TableCell>
                </StyledTableRow>
              ))
            ) : (
              <Box sx={{ p: 2 }}>
                <CircularProgress />
              </Box>
            )}
          </TableBody>
        </TableContainer>
        <ConfirmDialog open={open} name={"test123"} handleClose={handleClose} />
      </div>
    );
  }
};

export default ResultsTable;
